import React, { useId, useState } from 'react';

import './BadgeCheckbox.scss';

interface IBadgeCheckboxProps {
  title: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const BadgeCheckbox = ({ title, checked, onChange }: IBadgeCheckboxProps) => {
  const id = useId();
  const [checkboxChecked, setCheckboxChecked] = useState(checked);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const checked = event.target.checked;

    setCheckboxChecked(checked);
    onChange(checked);
  };

  return (
    <div className={`badge-checkbox ${checkboxChecked ? 'badge-checkbox--checked' : ''}`}>
      <input
        type="checkbox"
        className="badge-checkbox__input"
        id={id}
        checked={checkboxChecked}
        onChange={handleChange}
      />
      <label className="badge-checkbox__label" htmlFor={id}>
        <span>{title}</span>
      </label>
    </div>
  );
};

export default BadgeCheckbox;
